import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import WhatIsCountdownPopover from '@/components/WhatIsCountdownPopover/WhatIsCountdownPopover';
import { useBidCountdown } from '@/hooks/useBidCountdown';

type Props = PropsWithChildren<{
    timeStamp: number;
}>;

/**
 * Shows a countdown starting at 21 seconds for the current item
 */
const BidCountDown = ({ children, timeStamp }: Props) => {
    const { count, isLastFiveSeconds } = useBidCountdown(timeStamp);

    return (
        <CountDownContainer>
            {isLastFiveSeconds ? (
                <>
                    <BarDiv>
                        <ProgressDiv count={count} />
                    </BarDiv>
                    <MessageDiv>
                        <TextSpan aria-label="time left to bid">
                            <FormattedMessage
                                id="itemBidding.leftToBid"
                                values={{
                                    count: <CountSpan key="bid-count-down-count">{count}</CountSpan>,
                                }}
                            />
                        </TextSpan>
                        <WhatIsCountdownPopover />
                    </MessageDiv>
                </>
            ) : (
                children && <ChildWrapper>{children}</ChildWrapper>
            )}
        </CountDownContainer>
    );
};

export default BidCountDown;

const CountDownContainer = styled.div`
    width: 100%;
`;

const BarDiv = styled.div`
    height: 10px;
    background-color: ${({ theme }) => theme.colors.grey400};
    margin-bottom: 10px;
    position: relative;
`;

const ProgressDiv = styled.div<{ count }>`
    height: 10px;
    background-color: ${({ theme }) => theme.colors.red100};
    position: absolute;
    right: 0;
    transition: all 0.2s ease-in;
    width: ${(props) => `${(props.count / 5) * 100}%`};
`;

const MessageDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const TextSpan = styled.span`
    display: inline-block;
    min-width: 200px;
`;

const CountSpan = styled.span`
    color: ${({ theme }) => theme.colors.red100};
    font-weight: 600;
`;

const ChildWrapper = styled.div`
    margin-top: 20px;
`;
